import { useContext } from "react";
import WorkOrdersContext from "../context/WorkOrdersContext";

const useWorkOrders = () => {
    const {
        isWOSelected, 
        selectedWO,
        setIsWOSelected,
        setSelectedWO,
        futureWOs,
        todayWorkOrders,
        fetchWorkOrders,
        fetchNewOrders,
        cleanWorkOrders,
        setRemovedWO,
        removedWO
    } = useContext(WorkOrdersContext)

    return {
        isWOSelected,
        selectedWO,
        setIsWOSelected,
        setSelectedWO,
        futureWOs,
        todayWorkOrders,
        fetchWorkOrders,
        fetchNewOrders,
        cleanWorkOrders,
        setRemovedWO,
        removedWO,
    };
}

export default useWorkOrders